var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from "classnames";
var Filters = function (_a) {
    var categories = _a.categories, tags = _a.tags, disable = _a.disable, filterCallback = _a.filterCallback;
    var disabledClass = disable ? 'disabled' : '';
    var CloseIcon = function () {
        return (_jsx("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", className: "h-6 w-6 close-icon absolute top-1/2 right-1 transform !-translate-x-1/2 !-translate-y-1/2 duration-400 ease-in-out", fill: "none", viewBox: "0 0 24 24", stroke: "currentColor" }, { children: _jsx("path", { "stroke-linecap": "round", "stroke-linejoin": "round", "stroke-width": "2", d: "M6 18L18 6M6 6l12 12" }, void 0) }), void 0));
    };
    var cats = categories.map(function (cat, i) {
        var selectedClass = cat.selected ? 'active' : '';
        var Label = function (categories) { return _jsx("label", __assign({ htmlFor: cat.categoryId }, categories), void 0); };
        // @ts-ignore
        return _jsxs("label", __assign({ className: classNames('select mb-3 md:mb-5 relative', selectedClass, disabledClass, cat.categoryClass) }, { children: [_jsx("input", { component: Label, type: 'checkbox', onClick: function (e) { return filterCallback(e, i); }, name: 'category', value: cat.categoryId }, cat.categoryId), cat.categoryName, cat.selected ? _jsx(CloseIcon, {}, void 0) : null] }), i);
    });
    return _jsx("div", __assign({ className: classNames('story-filters') }, { children: _jsx("div", __assign({ className: classNames('story-filters__categories flex flex-wrap justify-center mt-5 px-4', disabledClass) }, { children: cats }), void 0) }), void 0);
};
export default Filters;
